/* Shared printable report layout. Used by Mock Recall + all 5 report pages. */
import React from 'react';
import { Button } from '../../components/ui/button';
import { Printer, FileDown } from 'lucide-react';

export function exportCsv(filename, rows, columns) {
  if (!rows?.length) return;
  const esc = (v) => {
    if (v == null) return '';
    const s = String(v).replace(/"/g, '""');
    return /[",\n]/.test(s) ? `"${s}"` : s;
  };
  const head = columns.map(c => esc(c.label)).join(',');
  const body = rows.map(r => columns.map(c => esc(typeof c.value === 'function' ? c.value(r) : r[c.key])).join(',')).join('\n');
  const csv = head + '\n' + body;
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename; document.body.appendChild(a); a.click();
  document.body.removeChild(a); URL.revokeObjectURL(url);
}

export default function ReportLayout({ title, subtitle, generated_at, children, onCsv, testid }) {
  return (
    <div className="space-y-4 print:p-8" data-testid={testid}>
      <div className="flex items-center justify-between gap-3 flex-wrap print:hidden">
        <div>
          <h1 className="text-xl font-semibold">{title}</h1>
          {subtitle && <p className="text-sm text-muted-foreground">{subtitle}</p>}
        </div>
        <div className="flex gap-2">
          {onCsv && <Button variant="outline" onClick={onCsv} data-testid="btn-export-csv"><FileDown className="w-4 h-4 mr-1" />Export CSV</Button>}
          <Button onClick={() => window.print()} data-testid="btn-print"><Printer className="w-4 h-4 mr-1" />Print</Button>
        </div>
      </div>

      {/* Print-only header */}
      <div className="hidden print:block border-b pb-4 mb-4">
        <div className="text-xs uppercase tracking-wider text-zinc-500">Keystone by CloudVoro</div>
        <h1 className="text-2xl font-semibold">{title}</h1>
        {subtitle && <div className="text-sm text-zinc-600 mt-1">{subtitle}</div>}
        {generated_at && <div className="text-xs text-zinc-500 mt-2">Generated {new Date(generated_at).toLocaleString()}</div>}
      </div>

      {children}
    </div>
  );
}
